module.exports = __webpack_public_path__ + "img/retail.3eaa51ec.webp";